import React from 'react';
import { motion } from 'framer-motion';
import { FaTelegram, FaInstagram, FaYoutube, FaTwitter } from 'react-icons/fa';

const SocialLinks = () => {
  const socialPlatforms = [
    {
      name: 'Telegram',
      icon: FaTelegram,
      url: 'https://t.me/main_bet',
      color: 'bg-blue-500 hover:bg-blue-600',
      textColor: 'text-white'
    },
    {
      name: 'Instagram',
      icon: FaInstagram,
      url: 'https://www.instagram.com/mainbetcom/',
      color: 'bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600',
      textColor: 'text-white'
    },
    {
      name: 'YouTube',
      icon: FaYoutube,
      url: '/',
      color: 'bg-red-600 hover:bg-red-700',
      textColor: 'text-white'
    },
    {
      name: 'Twitter',
      icon: FaTwitter,
      url: '/',
      color: 'bg-sky-500 hover:bg-sky-600',
      textColor: 'text-white'
    }
  ];

  return (
    <motion.div
      className="mt-8 mb-8"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg border border-gray-200 dark:border-gray-700">
        {/* Заголовок */}
        <div className="text-center mb-6">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Stay Connected
          </h3>
          <p className="text-gray-600 dark:text-gray-300">
            Follow us for the latest betting tips and exclusive offers
          </p>
        </div>

        {/* Социальные сети */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
          {socialPlatforms.map((platform, index) => {
            const IconComponent = platform.icon;
            return (
              <motion.a
                key={platform.name}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${platform.color} ${platform.textColor} p-4 rounded-lg font-semibold text-center transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg flex flex-col items-center gap-2`}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <IconComponent className="text-2xl sm:text-3xl" />
                <span className="text-sm sm:text-base">{platform.name}</span>
              </motion.a>
            );
          })}
        </div>

        {/* Дополнительный призыв к действию */}
        <div className="text-center mt-6 pt-6 border-t border-gray-200 dark:border-gray-600">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Join thousands of smart bettors who trust Main-Bet
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default SocialLinks; 